document.addEventListener('DOMContentLoaded', function() {
  const articleContent = document.querySelector('.article-content') || document.querySelector('.prose');
  if (!articleContent) return;
  
  let html = articleContent.innerHTML;
  const regex = /\[product_spotlight handle="([^"]+)"\]/g;
  if (!html.match(regex)) return;
  
  const replaceShortcodes = async () => {
    const matches = Array.from(html.matchAll(regex));
    
    for (const match of matches) {
      const fullMatch = match[0];
      const handle = match[1];
      
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) continue;
        const product = await response.json();
        
        let shortDescription = '';
        if (product.description) {
          shortDescription = product.description.replace(/<[^>]*>?/gm, '').trim();
          if (shortDescription.length > 160) {
            shortDescription = shortDescription.substring(0, 160) + '...';
          }
        }
        
        let selectedVariant = product.variants.find(v => v.title === "6") || product.variants[0];
        const price = (selectedVariant.price / 100).toFixed(2).replace('.', ',');
        
        const replacement = `
          <div class="impact-spotlight">
            <style>
              .impact-spotlight {
                background: #f9f9f9;
                margin: 40px 0;
                padding: 24px;
                border: 1px solid #e5e5e5;
                font-family: var(--text-font-family);
                color: var(--text-color);
              }
              .is-container {
                display: flex;
                flex-direction: column;
                gap: 20px;
              }
              .is-image-link {
                display: block;
                width: 100%;
                max-width: 150px;
                margin: 0 auto;
                flex-shrink: 0;
              }
              .is-image-link img {
                width: 100%;
                height: auto;
                object-fit: cover;
                transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);
              }
              .is-content {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
              }
              .is-title {
                font-family: var(--heading-font-family);
                font-weight: var(--heading-font-weight);
                font-size: 1.3rem;
                margin: 0 0 10px 0;
                color: var(--heading-color);
                line-height: 1.2;
              }
              
              /* DESCRIPTION : Masquée par défaut (mobile) */
              .is-description {
                display: none; 
                font-size: 0.95rem;
                line-height: 1.5;
                margin: 0 0 20px 0;
                opacity: 0.8;
              }
              
              .is-footer {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 15px;
                flex-wrap: wrap;
              }
              .is-price-wrapper {
                display: flex;
                flex-direction: column;
              }
              .is-price {
                font-size: 1.2rem;
                font-weight: 600;
              }
              .is-unit {
                font-size: 0.75rem;
                text-transform: uppercase;
                opacity: 0.6;
              }
              .is-add-button {
                background: var(--primary-button-background);
                color: var(--primary-button-text-color);
                border: none;
                padding: 10px 24px;
                font-size: 0.85rem;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.1em;
                cursor: pointer;
              }
              
              /* DESKTOP (A partir de 768px) */
              @media (min-width: 768px) {
                .is-container {
                  flex-direction: row;
                  gap: 24px;
                }
                .is-image-link {
                  width: 180px;
                  max-width: 180px;
                  margin: 0;
                }
                .is-title {
                  font-size: 1.6rem;
                }
                /* Affichage de la description uniquement sur Desktop */
                .is-description {
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                }
                .is-image-link:hover img {
                  transform: scale(1.05);
                }
              }

              /* Ajustement spécifique petit mobile */
              @media (max-width: 480px) {
                .is-footer {
                  justify-content: center;
                  text-align: center;
                }
                .is-title {
                  text-align: center;
                }
                .is-add-button {
                  width: 100%;
                }
              }
            </style>
            
            <div class="is-container">
              <a href="/products/${handle}" class="is-image-link">
                <img src="${product.featured_image}" alt="${product.title}">
              </a>
              
              <div class="is-content">
                <h3 class="is-title">${product.title}</h3>
                <p class="is-description">${shortDescription}</p>
                
                <div class="is-footer">
                  <div class="is-price-wrapper">
                    <span class="is-price">${price} €</span>
                    <span class="is-unit">Lot de 6</span>
                  </div>
                  
                  <form method="post" action="/cart/add">
                    <input type="hidden" name="id" value="${selectedVariant.id}">
                    <button type="submit" class="is-add-button">
                      <span>Commander</span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        `;
        
        html = html.replace(fullMatch, replacement);
      } catch (error) {
        console.error('Erreur :', error);
      }
    }
    articleContent.innerHTML = html;
  };
  
  replaceShortcodes();
});